import React from 'react';
import { Skeleton } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  skeletonContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    gap: theme.spacing(2),
    padding: theme.spacing(2)
  },
  skeletonLeft: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  skeletonRight: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  skeletonGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
    gap: theme.spacing(2),
    flex: 1
  }
}));

export function CollectionSkeleton(): JSX.Element {
  const { classes } = useStyles();

  return (
    <div className={classes.skeletonContainer}>
      <div className={classes.skeletonLeft}>
        <Skeleton variant="rectangular" height={60} animation="wave" />
        <Skeleton variant="rectangular" height={120} animation="wave" />
        <Skeleton variant="rectangular" sx={{ flex: 1 }} animation="wave" />
      </div>
      <div className={classes.skeletonRight}>
        <Skeleton variant="rectangular" height={40} animation="wave" />
        <div className={classes.skeletonGrid}>
          {Array.from({ length: 12 }).map((_, i) => (
            <Skeleton key={i} variant="rectangular" height={200} animation="wave" />
          ))}
        </div>
      </div>
    </div>
  );
}
